import { ChangeDetectionStrategy, Component, InputSignal, Signal, computed, input } from '@angular/core';

import { IBlock, prosConsOfContent } from '@rt-tools/cms-contract';
import { BlockDirective, ElemDirective } from '@rt-tools/core';

const BEM_BLOCK: string = 'sc-blog-pros-cons-block';

@Component({
    selector: 'sc-blog-pros-cons-block',
    templateUrl: './blog-pros-cons-block.component.html',
    styleUrl: './blog-pros-cons-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // rt-tools
        BlockDirective,
        ElemDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class BlogProsConsBlockComponent {
    // Пустой заголовок стороны остаётся пустым: шаблон подставляет переведённую подпись.
    protected readonly prosCons: Signal<IBlock.Content.ProsCons> = computed(() => prosConsOfContent(this.content(), '', ''));

    /** Содержимое блока плюсов и минусов. */
    public readonly content: InputSignal<string> = input.required<string>();
}
